import { render } from "./RolledDice.vue?vue&type=template&id=f12eb33e&ts=true"
import script from "./RolledDice.vue?vue&type=script&lang=ts"
export * from "./RolledDice.vue?vue&type=script&lang=ts"

import "./RolledDice.vue?vue&type=style&index=0&id=f12eb33e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__